import { get, isNumber } from "lodash-es";

export default {
  methods: {
    adaptarVueModel(arreglo, primaryKey, allowZero = false) {
      const val = this.value;

      if (allowZero) {
        if (isNumber(val)) {
          this.$emit(
            "input",
            arreglo.find((el) => get(el, `[${primaryKey}]`, null) === val),
          );
        }
      } else {
        if (val === 0) {
          this.$emit("input", null);
        }
        if (isNumber(val) && val > 0) {
          this.$emit(
            "input",
            arreglo.find((el) => get(el, `[${primaryKey}]`, null) === val),
          );
        }
      }
    },
  },
};
